import { render, staticRenderFns } from "./ResellerInvite.vue?vue&type=template&id=e7e79f4a&"
import script from "./ResellerInvite.vue?vue&type=script&lang=js&"
export * from "./ResellerInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7e79f4a')) {
      api.createRecord('e7e79f4a', component.options)
    } else {
      api.reload('e7e79f4a', component.options)
    }
    module.hot.accept("./ResellerInvite.vue?vue&type=template&id=e7e79f4a&", function () {
      api.rerender('e7e79f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/ResellerInvite.vue"
export default component.exports